import { getCookieValue, getSuffix } from '@helsenorge/framework-utils/cookie';
import { setSharedCookie } from '@helsenorge/framework-utils/shared-cookies';
// Navn på cookie der lukkede driftsmeldinger lagres
export const DRIFTSMELDING_COOKIE_NAME = 'hn-driftsmelding-closed';
// Levetid på cookie i dager
export const DRIFTSMELDING_COOKIE_EXPIRES_DAYS = 183;
/**
 * Returnerer navnet på cookien som lagrer lukkede driftsmeldinger.
 *
 * @returns Navn på cookie
 */
export const getDriftsmeldingCookieName = () => getSuffix(DRIFTSMELDING_COOKIE_NAME);
// Konverter cookie-verdi til objekt med id og timestamp
export const parseDriftsmeldingCookie = (value) => {
    return value
        .split('|')
        .filter(Boolean)
        .reduce((acc, pair) => {
        const [id, timestamp] = pair.split(':');
        if (id && timestamp) {
            acc[id] = Number(timestamp);
        }
        return acc;
    }, {});
};
// Konverter objekt med id og timestamp til cookie-verdi
export const stringifyDriftsmeldingCookie = (existing) => {
    return Object.entries(existing)
        .map(([id, timestamp]) => `${id}:${timestamp}`)
        .join('|');
};
// Legg til driftsmelding-id og timestamp i eksisterende cookie-objekt
export const getUpdatedCookie = (existing, id, ts) => {
    return {
        ...existing,
        [id]: ts,
    };
};
// Hent lukkede driftsmeldinger fra cookie
export const getClosedMeldinger = () => {
    const existing = getCookieValue(DRIFTSMELDING_COOKIE_NAME);
    return existing ? parseDriftsmeldingCookie(existing) : {};
};
// Oppdater driftsmelding-cookie med ny lukket melding
export const setDriftsmeldingCookie = (id, timestamp) => {
    const existing = getClosedMeldinger();
    const updated = getUpdatedCookie(existing ?? {}, id, timestamp);
    const stringified = stringifyDriftsmeldingCookie(updated);
    setSharedCookie(getDriftsmeldingCookieName(), stringified, DRIFTSMELDING_COOKIE_EXPIRES_DAYS);
};
